// Search photos: greedy masonry + load-more. Vanilla; kept separate from search.js on purpose (do not merge).
(function () {
    function ready(fn) {
        if (document.readyState !== 'loading') fn();
        else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
        // data-ar (server-provided) lets the fill run before images paint, avoiding a reflow flash.
        function colCount(grid) {
            var n = parseInt(getComputedStyle(grid).getPropertyValue('--cols'), 10);
            return n > 0 ? n : 1;
        }

        function ratio(item) {
            return parseFloat(item.getAttribute('data-ar')) || 1;
        }

        function shortest(heights) {
            var t = 0;
            for (var k = 1; k < heights.length; k++) {
                if (heights[k] < heights[t]) t = k; // strict < keeps the leftmost on ties
            }
            return t;
        }

        // Append one tile to the shortest column, updating the running heights.
        function place(grid, item) {
            var t = shortest(grid.__heights);
            grid.__colEls[t].appendChild(item);
            grid.__heights[t] += ratio(item);
        }

        // (Re)build `cols` empty columns and distribute the cached flat tile list.
        function build(grid, cols) {
            var colEls = [];
            var heights = [];
            for (var i = 0; i < cols; i++) {
                var col = document.createElement('div');
                col.className = 'search-photos-grid__col';
                colEls.push(col);
                heights.push(0);
            }
            grid.__cols = cols;
            grid.__colEls = colEls;
            grid.__heights = heights;

            for (var j = 0; j < grid.__items.length; j++) place(grid, grid.__items[j]);

            grid.innerHTML = '';
            for (var c = 0; c < colEls.length; c++) grid.appendChild(colEls[c]);
            grid.classList.add('is-masonry');
        }

        // JS measures the crop height (CSS can't take the min of column heights).
        function applyCrop(grid) {
            if (!grid.hasAttribute('data-photos-crop') || !grid.__colEls || !grid.__colEls.length) return;
            var min = Infinity;
            for (var i = 0; i < grid.__colEls.length; i++) {
                var h = grid.__colEls[i].getBoundingClientRect().height;
                if (h > 0 && h < min) min = h;
            }
            if (min === Infinity) return;
            // Cut just past the shortest column so a sliver of the next row peeks (reads as "more below").
            grid.style.maxHeight = Math.max(0, Math.round(min) + 2) + 'px';
            grid.style.overflow = 'hidden';
        }

        // Tags the bottom rows for the CSS paywall blur; exports --locked-band for the teaser to center on.
        function markLocked(grid) {
            if (!grid.__items) return;
            var LOCKED = 'search-photos-grid__item--locked';
            for (var i = 0; i < grid.__items.length; i++) {
                grid.__items[i].classList.remove(LOCKED);
                grid.__items[i].style.removeProperty('--locked-blur');
                grid.__items[i].style.removeProperty('--locked-scale');
            }
            var funnel = grid.closest('.search-photos-funnel');
            if (funnel) funnel.style.removeProperty('--locked-band');
            if (!grid.hasAttribute('data-photos-locked') || !grid.__colEls) return;

            var gridTop = grid.getBoundingClientRect().top;
            var cropH = grid.style.maxHeight ? parseFloat(grid.style.maxHeight) : grid.scrollHeight;
            var bp = (typeof detectBreakpoint === 'function')
                ? detectBreakpoint(window.innerWidth)
                : (window.innerWidth < 600 ? 's' : window.innerWidth < 720 ? 't' : window.innerWidth < 1040 ? 'tm' : 'd');
            var BAND = { s: 0.42, t: 0.4, tm: 0.36, d: 0.22 };
            var FLOOR = { s: 0.45, t: 0.4, tm: 0.35, d: 0.12 };
            var floor = FLOOR[bp] != null ? FLOOR[bp] : 0.4;
            var bandThreshold = cropH - grid.clientWidth * (BAND[bp] != null ? BAND[bp] : 0.34);

            // Read phase: collect locked tiles + their tops (no writes here, avoids layout thrash).
            var locked = [], tops = [];
            for (var c = 0; c < grid.__colEls.length; c++) {
                var kids = grid.__colEls[c].children;
                for (var k = 0; k < kids.length; k++) {
                    // Skip the server-blurred teaser tail (thin tags) so it isn't blurred twice.
                    if (kids[k].classList.contains('search-photos-grid__item--blur')) continue;
                    var top = kids[k].getBoundingClientRect().top - gridTop;
                    // Band by the tile MIDPOINT (not its bottom) so a mostly-above tile doesn't stick up blurred.
                    // Bottom-edge net: also lock the last tile of a multi-tile column (covers short thin-result
                    // columns whose midpoint barely clears the band); `k > 0` keeps the first row sharp always
                    // (scarce thin results stay unblurred, teaser overlay alone gates them).
                    if (k > 0 && (top + kids[k].offsetHeight / 2 > bandThreshold || k === kids.length - 1)) {
                        locked.push(kids[k]);
                        tops.push(top);
                    }
                }
            }
            if (!locked.length) return;

            var regionTop = Math.min.apply(null, tops);
            var regionH = Math.max(1, cropH - regionTop);
            var maxBlur = grid.clientWidth * 0.04; // px blur at the region bottom
            for (var n = 0; n < locked.length; n++) {
                var depth = Math.max(0, Math.min(1, (tops[n] - regionTop) / regionH));
                var ratio = floor + (1 - floor) * depth; // floor at the top, full blur at the bottom
                locked[n].classList.add(LOCKED);
                locked[n].style.setProperty('--locked-blur', (ratio * maxBlur).toFixed(1) + 'px');
                locked[n].style.setProperty('--locked-scale', (1 + ratio * 0.1).toFixed(3));
            }
            if (funnel) funnel.style.setProperty('--locked-band', Math.round(regionH) + 'px');
        }

        function layout(grid) {
            // Cache the server-rendered flat tile list once (kept across relayouts).
            if (!grid.__items) {
                grid.__items = Array.prototype.slice.call(grid.querySelectorAll(':scope > [data-ar]'));
            }
            var cols = colCount(grid);
            if (grid.__cols !== cols) build(grid, cols); // rebuild only on column-count change
            applyCrop(grid); // every layout: column widths (and so heights) change on resize
            markLocked(grid);
        }

        function layoutAll() {
            var grids = document.querySelectorAll('[data-photos-grid]');
            for (var i = 0; i < grids.length; i++) layout(grids[i]);
        }

        // Continue the greedy fill with new tiles (prefix-stable: nothing on screen moves).
        function appendItems(grid, items) {
            for (var i = 0; i < items.length; i++) {
                grid.__items.push(items[i]);
                place(grid, items[i]);
            }
        }

        layoutAll();

        var resizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(layoutAll, 150);
        });

        // Photos tab load-more (infinite/manual)
        var section = document.querySelector('[data-section="photos-results"]');
        if (!section) return;

        if (!section.querySelector('[data-photos-grid]')) return;

        if (section.dataset.photosLoadMoreInit) return;
        section.dataset.photosLoadMoreInit = '1';

        var loading = false;
        var clickedOnce = false;
        var observer = null;

        function wrapEl() {
            return section.querySelector('[data-photos-load-more-wrap]');
        }

        function autoButton() {
            return section.querySelector('[data-photos-load-more][data-photos-autoload]');
        }

        function stopObserving() {
            if (observer) {
                observer.disconnect();
                observer = null;
            }
        }

        // Gated funnel: the paywall crop/blur belongs to the whole tier stack, not one grid —
        // it sits on the stack's LAST grid only. A merge can change which grid is last, so
        // re-point the flags and restyle (a formerly-last grid uncrops and unblurs).
        function syncFunnel() {
            var funnel = section.querySelector('.search-photos-funnel');
            if (!funnel) return;
            var grids = funnel.querySelectorAll('[data-photos-grid]');
            for (var i = 0; i < grids.length; i++) {
                if (i === grids.length - 1) {
                    grids[i].setAttribute('data-photos-crop', '');
                    grids[i].setAttribute('data-photos-locked', '');
                } else if (grids[i].hasAttribute('data-photos-crop')) {
                    grids[i].removeAttribute('data-photos-crop');
                    grids[i].removeAttribute('data-photos-locked');
                    grids[i].style.removeProperty('max-height');
                    grids[i].style.removeProperty('overflow');
                }
                applyCrop(grids[i]);
                markLocked(grids[i]);
            }
        }

        function armAutoload() {
            stopObserving();
            if (!clickedOnce || typeof IntersectionObserver === 'undefined') return;
            var button = autoButton();
            var sentinel = wrapEl();
            if (!button || !sentinel) return;
            observer = new IntersectionObserver(function (entries) {
                if (entries[0].isIntersecting) {
                    stopObserving();
                    loadMore();
                }
            }, { rootMargin: '600px 0px' });
            observer.observe(sentinel);
            button.style.display = 'none';
        }

        function loadMore() {
            var link = section.querySelector('[data-photos-load-more]');
            var url = link ? link.getAttribute('href') : '';
            if (loading || !url) return;
            loading = true;
            var failed = false;

            fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                .then(function (res) {
                    if (!res.ok) throw new Error('HTTP ' + res.status);
                    return res.text();
                })
                .then(function (html) {
                    var tmp = document.createElement('div');
                    tmp.innerHTML = html;

                    // An unrecognized/empty fragment must not tear down the funnel CTA - treat as a failed load.
                    if (!tmp.querySelector('[data-photos-tier-block]')
                        && !tmp.querySelector('.search-photos-funnel .search-photos-teaser')
                        && !tmp.querySelector('[data-photos-load-more-wrap]')) {
                        throw new Error('empty fragment');
                    }

                    // ONE merge path for every access state: each fragment block's tiles land in
                    // the same-tier grid; a tier not on the page yet arrives whole, so its h2
                    // lands with its first tiles. Tier order is monotonic across pages ->
                    // appending keeps order. The gate fragment has no blocks (teaser swap only).
                    var newBlocks = tmp.querySelectorAll('[data-photos-tier-block]');
                    var host = section.querySelector('[data-photos-tiers]');
                    if (newBlocks.length && host) {
                        for (var b = 0; b < newBlocks.length; b++) {
                            var tier = newBlocks[b].getAttribute('data-photos-tier-block');
                            var target = host.querySelector('[data-photos-tier-block="' + tier + '"] [data-photos-grid]');
                            if (target) {
                                appendItems(target, Array.prototype.slice.call(newBlocks[b].querySelectorAll('.search-photos-grid > [data-ar]')));
                            } else {
                                host.appendChild(newBlocks[b]);
                                var addedGrid = newBlocks[b].querySelector('[data-photos-grid]');
                                if (addedGrid) layout(addedGrid);
                            }
                        }
                        syncFunnel(); // gated: crop/blur follows the stack's last grid
                    }

                    if (window.initializeDynamicContent) {
                        window.initializeDynamicContent({ container: section });
                    }

                    // Swap the teaser overlay in place; payers have none, so move the plain load-more wrap.
                    var oldTeaser = section.querySelector('.search-photos-funnel .search-photos-teaser');
                    var newTeaser = tmp.querySelector('.search-photos-funnel .search-photos-teaser');
                    if (oldTeaser) {
                        if (newTeaser) oldTeaser.replaceWith(newTeaser);
                        else oldTeaser.remove();
                    } else {
                        var oldWrap = wrapEl();
                        if (oldWrap) oldWrap.remove();
                        var newWrap = tmp.querySelector('[data-photos-load-more-wrap]');
                        if (newWrap) section.appendChild(newWrap);
                    }
                })
                .catch(function (err) {
                    console.error('photos load-more failed', err);
                    failed = true;
                })
                .finally(function () {
                    loading = false;
                    if (failed) {
                        // No retry storm: disarm and reshow the button for a manual retry.
                        stopObserving();
                        var button = autoButton();
                        if (button) button.style.display = '';
                    } else {
                        armAutoload();
                    }
                });
        }

        section.addEventListener('click', function (e) {
            // A locked tile fires the teaser CTA (not the gallery) so the blurred rows act as one CTA.
            var lockedTile = e.target.closest('.search-photos-grid__item--locked');
            if (lockedTile && section.contains(lockedTile)) {
                e.preventDefault();
                var cta = section.querySelector('.search-photos-teaser [data-photos-load-more], .search-photos-teaser [data-photos-join]');
                if (cta) cta.click();
                return;
            }
            var trigger = e.target.closest('[data-photos-load-more], [data-photos-join]');
            if (!trigger || !section.contains(trigger)) return;
            e.preventDefault();
            if (trigger.hasAttribute('data-photos-join')) {
                var join = trigger.getAttribute('href');
                if (join) window.location.href = join;
                return;
            }
            clickedOnce = true;
            loadMore();
        });
    });
})();

// Sites tab load-more: fetch the next page's card fragment and append it. Plain manual
// button (no masonry/infinite-scroll) — the /search-sites list is a short paginated set.
(function () {
    function ready(fn) {
        if (document.readyState !== 'loading') fn();
        else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
        var section = document.querySelector('[data-section="results-sites"]');
        if (!section || section.dataset.sitesLoadMoreInit) return;
        section.dataset.sitesLoadMoreInit = '1';

        var grid = section.querySelector('[data-sites-grid]');
        if (!grid) return;

        var loading = false;

        function button() {
            return section.querySelector('[data-sites-load-more]');
        }

        // Bump the page-N segment of the load-more URL to the next page.
        function nextPageUrl(url) {
            return url.replace(/page-(\d+)\//, function (_, n) {
                return 'page-' + (parseInt(n, 10) + 1) + '/';
            });
        }

        function loadMore() {
            var link = button();
            var url = link ? link.getAttribute('href') : '';
            if (loading || !url) return;
            loading = true;

            fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                .then(function (res) {
                    if (!res.ok) throw new Error('HTTP ' + res.status);
                    return res.text();
                })
                .then(function (html) {
                    var tmp = document.createElement('div');
                    tmp.innerHTML = html;
                    var cards = tmp.querySelectorAll('.site-card');
                    var perPage = cards.length; // full page on the first fetch sets the stride
                    for (var i = 0; i < cards.length; i++) grid.appendChild(cards[i]);

                    if (window.initializeDynamicContent) {
                        window.initializeDynamicContent({ container: section });
                    }

                    // A short fragment means the list ran out — drop the button; else advance it.
                    var wrap = section.querySelector('[data-sites-load-more-wrap]');
                    var prevPerPage = parseInt(section.dataset.sitesStride || '0', 10);
                    if (!prevPerPage && perPage) section.dataset.sitesStride = perPage;
                    var stride = prevPerPage || perPage;
                    if (!cards.length || (stride && cards.length < stride)) {
                        if (wrap) wrap.remove();
                    } else if (link) {
                        link.setAttribute('href', nextPageUrl(url));
                    }
                })
                .catch(function (err) {
                    console.error('sites load-more failed', err);
                })
                .finally(function () {
                    loading = false;
                });
        }

        section.addEventListener('click', function (e) {
            var trigger = e.target.closest('[data-sites-load-more]');
            if (!trigger || !section.contains(trigger)) return;
            e.preventDefault();
            loadMore();
        });
    });
})();

// Search-photos lightbox: paywall CTA for visitors, gallery + watch-episode CTA for members.
// jQuery only because magnific-popup is a jQuery plugin; masonry stays vanilla.
(function () {
    function ready(fn) {
        if (document.readyState !== 'loading') fn();
        else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
        var $ = window.jQuery;
        if (!$ || !$.fn || !$.fn.magnificPopup) return;

        var results = document.querySelector('[data-section="photos-results"]');
        // Exactly one of the two renders: pw = tour paywall, ep = member "watch episode".
        var pwTemplate = document.querySelector('template[data-pw-overlay]');
        var template = pwTemplate || document.querySelector('template[data-ep-overlay]');
        if (!results || !template) return;

        var isMember = !pwTemplate;
        var overlay = template.innerHTML;
        // Counter: total is server-formatted and only present where it is an honest photo count.
        var photoTotal = template.getAttribute('data-photo-total');
        var photoCounter = template.getAttribute('data-photo-counter');

        var DELEGATE = 'a.open:not(.search-photos-grid__item--locked)';
        var PREFETCH_MARGIN = 3;

        function loadMoreLink() {
            return results.querySelector('[data-photos-load-more]');
        }

        function itemEl(item) {
            return item && item.el ? item.el[0] : item;
        }

        function itemPos(item) {
            var el = itemEl(item);
            return (el && el.getAttribute && parseInt(el.getAttribute('data-pos'), 10)) || 0;
        }

        // Tiles also arrive from the page's own autoload, not just our prefetch - without this
        // the collection stays frozen at its size on open and the last arrow wraps.
        function syncItems() {
            var mfp = $.magnificPopup.instance;
            if (!mfp || !mfp.isOpen || !mfp.items) return;
            var known = [];
            for (var i = 0; i < mfp.items.length; i++) known.push(itemEl(mfp.items[i]));
            var live = results.querySelectorAll(DELEGATE);
            var added = 0;
            for (var j = 0; j < live.length; j++) {
                if (known.indexOf(live[j]) === -1) {
                    mfp.items.push(live[j]);
                    added++;
                }
            }
            if (!added) return;
            var current = mfp.items[mfp.index];
            mfp.items.sort(function (a, b) { return itemPos(a) - itemPos(b); });
            var k = mfp.items.indexOf(current);
            if (k > -1) mfp.index = k;
            // parseEl stamps item.index on visited items; the sort moved them.
            for (var n = 0; n < mfp.items.length; n++) {
                if (mfp.items[n] && mfp.items[n].parsed) mfp.items[n].index = n;
            }
            mfp.updateGalleryButtons();
        }

        // updateGalleryButtons hides the next arrow on the last item, even when a next page
        // exists - the handlers below fetch it on demand.
        function keepNextArrow(mfp) {
            if (mfp.arrowNext && loadMoreLink()) mfp.arrowNext.show();
        }

        var pendingFetch = false;
        // Bumped on every open. The instance is a singleton, so a poll left over from a closed
        // session would otherwise resume against whatever is open 200ms later.
        var openGeneration = 0;

        // Not the vendor's 'mfp-loading': that hides the figure whole, close button included.
        function showFetching(mfp) {
            mfp.wrap.addClass('is-fetching');
            mfp.updateStatus('loading');
        }

        function endFetching(mfp) {
            mfp.wrap.removeClass('is-fetching');
            mfp.updateStatus('ready');
        }

        // With loop off, next() returns early on the last item, so the click reads as dead while
        // the next page simply has not been fetched yet. Fetch it, then advance.
        function advanceAfterFetch(mfp) {
            if (pendingFetch || !loadMoreLink()) return;
            pendingFetch = true;
            var generation = openGeneration;
            var startCount = mfp.items.length;
            var tries = 0;
            showFetching(mfp);
            loadMoreLink().click();
            (function poll() {
                if (!pendingFetch || !mfp.isOpen || generation !== openGeneration) {
                    pendingFetch = false;
                    return;
                }
                if (mfp.items.length > startCount) {
                    pendingFetch = false;
                    endFetching(mfp);
                    mfp.next();
                    return;
                }
                // No link left means that was the last page; 75 * 200ms ~= 15s is the give-up cap.
                if (!loadMoreLink() || ++tries > 75) {
                    pendingFetch = false;
                    endFetching(mfp);
                    mfp.updateGalleryButtons();
                    return;
                }
                setTimeout(poll, 200);
            })();
        }

        function prefetchMore(mfp) {
            if (mfp.index < mfp.items.length - PREFETCH_MARGIN) return;
            var link = loadMoreLink();
            if (link) link.click();
        }

        function atLoadedEnd(mfp) {
            return (
                mfp &&
                mfp.isOpen &&
                mfp.index >= mfp.items.length - 1 &&
                !!loadMoreLink()
            );
        }

        // Capture on an ancestor, not the arrow: on the target element a capture listener still
        // runs in registration order, and magnific bound its own first. Keydown needs it too.
        if (isMember) {
            document.addEventListener(
                'click',
                function (e) {
                    if (!e.target.closest || !e.target.closest('.mfp-arrow-right')) return;
                    var mfp = $.magnificPopup.instance;
                    if (!atLoadedEnd(mfp)) return;
                    e.preventDefault();
                    e.stopPropagation();
                    advanceAfterFetch(mfp);
                },
                true
            );

            // 39 = right. No RTL locale ships here, so next is always the right key.
            document.addEventListener(
                'keydown',
                function (e) {
                    if (e.keyCode !== 39) return;
                    var mfp = $.magnificPopup.instance;
                    if (!atLoadedEnd(mfp)) return;
                    e.preventDefault();
                    e.stopPropagation();
                    advanceAfterFetch(mfp);
                },
                true
            );
        }

        if (isMember && typeof MutationObserver !== 'undefined') {
            new MutationObserver(function () { syncItems(); })
                .observe(results, { childList: true, subtree: true });
        }

        // Bound to the section, not a grid: the masonry rebuilds grids and load-more appends tiles.
        // Locked tiles are excluded - the handler above already owns their click.
        $(results).magnificPopup({
            delegate: DELEGATE,
            type: 'image',
            removalDelay: 300,
            // Scopes the arrow/CTA layout below - the detail page lightbox shares _lightbox.scss.
            mainClass: 'mfp-fade mfp-search-photos',
            autoFocusLast: false,
            fixedContentPos: false,
            fixedBgPos: false,
            tLoading: '',
            gallery: isMember
                ? {
                      enabled: true,
                      // Wrapping would send the last loaded tile back to the first one.
                      loop: false,
                      arrowMarkup:
                          '<button title="%title%" class="mfp-arrow mfp-arrow-%dir%">\n' +
                          '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" viewBox="0 0 50 50">\n' +
                          '  <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m28.5 35-10-10 10-10"/>\n' +
                          '</svg>\n' +
                          '</button>'
                  }
                : { enabled: false },
            image: {
                cursor: null,
                markup:
                    '<div class="mfp-figure">' +
                    '<div class="mfp-close"></div>' +
                    '<div class="mfp-img"></div>' +
                    (photoTotal
                        ? '<div class="mfp-bottom-bar"><div class="mfp-counter p p3 text--c-white"></div></div>'
                        : '') +
                    '</div>'
            },
            closeMarkup:
                '<button title="%title%" class="mfp-close">\n' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">\n' +
                '  <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m4 4 16 16m0-16L4 20"/>\n' +
                '</svg>\n' +
                '</button>',
            callbacks: {
                beforeOpen: function () {
                    // Masonry moves tiles into column wrappers, so DOM order is not reading
                    // order. data-pos is the visual rank, and the number the counter shows.
                    if (!isMember || !this.items || this.items.length < 2) return;
                    var current = this.items[this.index];
                    this.items.sort(function (a, b) { return itemPos(a) - itemPos(b); });
                    var i = this.items.indexOf(current);
                    if (i > -1) this.index = i;
                },
                // Before the image starts loading, so the placeholder already has its shape.
                beforeChange: function () {
                    var item = this.items[this.index];
                    var el = itemEl(item);
                    var ar = el && el.getAttribute && el.getAttribute('data-ar');
                    // setProperty, not $.css: jQuery does not write custom properties reliably.
                    this.wrap[0].style.setProperty('--mfp-photo-ar', ar || '0.5625');
                },
                open: function () {
                    openGeneration++;
                    if (isMember) keepNextArrow(this);
                },
                change: function () {
                    if (!isMember) return;
                    // Mid-fetch means the user navigated themselves - drop the pending advance,
                    // or the landing page would jump them forward.
                    if (pendingFetch) {
                        pendingFetch = false;
                        endFetching(this);
                    }
                    syncItems();
                    prefetchMore(this);
                },
                // Runs after the gallery module's own updateGalleryButtons on the same event.
                updateStatus: function () {
                    if (isMember) keepNextArrow(this);
                },
                // Synchronous, before the figure is appended: with the gallery on, magnific
                // writes its own counter here and its total is only the tiles loaded so far.
                markupParse: function (template, values, item) {
                    if (!photoTotal || !photoCounter) return;
                    var pos = item && item.el && item.el.attr && item.el.attr('data-pos');
                    if (!pos) return;
                    // photoCounter is the server-translated phrase with {total} already filled in.
                    values.counter = photoCounter.split('{current}').join(pos);
                },
                imageLoadComplete: function () {
                    var content = this.content;
                    if (!content || !content.length) return;
                    var $figure = content.hasClass('mfp-figure') ? content : content.find('.mfp-figure');
                    if (!$figure.length) return;
                    $figure.children('.pw-overlay, .ep-overlay').remove();
                    $figure.append(overlay);

                    // The CTA is per-tile: each photo belongs to a different episode.
                    if (!isMember) return;
                    var el = (this.currItem && this.currItem.el) || this.st.el;
                    // Arrow navigation reaches tiles nobody touched: add their exit params before the copy
                    if (el && el.is('a.exit')) {
                        decorateExitLink(el[0]);
                    }
                    var href = el && el.attr && el.attr('href');
                    $figure.children('.ep-overlay').attr('href', href || '');
                },
                // Magnific parks the arrows in .mfp-container by default, which scrolls on mobile.
                buildControls: function () {
                    if (!this.arrowLeft) return;
                    this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                }
            }
        });
    });
})();
